<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card-group mb-4">
            <div class="card p-4">
              <div class="card-body">
                <h1>{{$t('REGISTER')}}</h1>
                <p class="text-muted">{{$t('REGISTERYOURACCOUNT')}}</p>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="username">
                      <div class="input-group">
                        <span class="input-group-addon"><icon name="user"></icon></span>
                        <input type="text" v-model="formData.username" class="form-control" v-bind:placeholder="$t('USERNAME')">
                      </div>
                    </inputvalidation>
                  </div>
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="userEmail">
                      <div class="input-group">
                        <span class="input-group-addon"><icon name="envelope"></icon></span>
                        <input type="text" v-model="formData.userEmail" class="form-control" v-bind:placeholder="$t('EMAIL')">
                      </div>
                    </inputvalidation>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="password">
                      <div class="input-group">
                        <span class="input-group-addon"><icon name="lock"></icon></span>
                        <input type="password" v-model="formData.password" class="form-control" v-bind:placeholder="$t('PASSWORD')">
                      </div>
                    </inputvalidation>
                  </div>
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="repeatpassword">
                      <div class="input-group">
                        <span class="input-group-addon"><icon name="lock"></icon></span>
                        <input type="password" v-model="formData.repeatpassword" class="form-control" v-bind:placeholder="$t('REPEATPASSWORD')">
                      </div>
                    </inputvalidation>
                  </div>
                </div>
                <div class="row mb-4">
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="name">
                      <div class="input-group">
                        <input type="text" v-model="formData.name" class="form-control" v-bind:placeholder="$t('NAME')">
                      </div>
                    </inputvalidation>
                  </div>
                  <div class="col-md-6">
                    <inputvalidation :formerror="formError" name="surname">
                      <div class="input-group">
                        <input type="text" v-model="formData.surname" class="form-control" v-bind:placeholder="$t('SURNAME')">
                      </div>
                    </inputvalidation>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-12">
                    <inputvalidation :formerror="formError" name="companyName">
                      <div class="input-group">
                        <input type="text" v-model="formData.companyName" class="form-control" v-bind:placeholder="$t('YOUROBJECTNAME')">
                      </div>
                    </inputvalidation>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="formError.error && formError.notice && typeof formError.notice == 'string'">{{formError.notice}}</p>
                  </div>
                  <div class="col-12">
                    <button type="button" v-on:click.prevent="register" class="btn btn-primary px-4">{{$t('REGISTER')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Api from '@/api/admin/Users';

export default {
    name: 'Register',
    data()
    {
        return {
            formData:
      {
          username: '',
          password: '',
          repeatpassword: '',
          userEmail: '',
          companyName: '',
      },
            formError: {},
        };
    },
    methods:
  {
      ...mapActions({
          actLogin: 'login',
      }),
      register()
      {
          const me = this;
          Api.registerUser(me.formData, function (data)
          {
              if (data.error == true)
              {
                  me.formError = data;
              }
              else
              {
                  me.actLogin({ username: me.formData.username, password: me.formData.password });
              }
          });
      },
  },
    computed:
  {

  },
};
</script>
